<ng-container>
  <div class="row sloanProjectSettings">
    <div class="col-6 nopad">
      <input type="checkbox" [checked]="isChecked(configurator.configurationUid)" (change)="changeCheckBox($event)" />
    </div>
    <div class="col-6 text-right nopad">
      <div ngbDropdown container="body">
        <button class="btn" ngbDropdownToggle>
          <img src="/images/ellipsis.svg" />
        </button>
        <div ngbDropdownMenu class="w-100 dropdown-menu">
          @if (isConfigLocked()) {
            <a (click)="openAproveDesign()" ngbDropdownItem>
              <img src="/images/project-approve-design.svg" />
              {{ 'configuratorsList.approveDesigns' | cxTranslate }}
            </a>
          }
          @if (canShowOption()) {
            <a (click)="openViewNotes()" ngbDropdownItem>
              <img src="/images/project-notes.svg" />
              {{ 'configuratorsList.viewNotes' | cxTranslate }}
            </a>
          }
          @if (canShowOption()) {
            <a ngbDropdownItem (click)="duplicateConfig()">
              <img src="/images/project-duplicate.svg" />
              {{ 'configuratorsList.duplicate' | cxTranslate }}
            </a>
          }
          @if (isConfigLocked()) {
            <a (click)="deleteConfig()" ngbDropdownItem>
              <img src="/images/project-delete.svg" />
              {{ 'configuratorsList.delete' | cxTranslate }}
            </a>
          }
          @if (isChecked(configurator.configurationUid) && configurator.status === 'APPROVED_LOCKED') {
            <a
              class="px-3 py-3 disabled text-success"
              >
              <img src="/images/project-approve-design.svg" />
              {{ 'configuratorsList.approved' | cxTranslate }}
            </a>
          }
        </div>
      </div>
    </div>
  </div>
  <a class="sloanProjectCard">
    <div class="img-hover">
      @if (configurator.threeKitData && configurator.threeKitData.length > 0) {
        <img [src]="configurator.threeKitData[0].metadata.tileImage" class="img-fluid img-thumbnail" alt="..." />
      }
      @if (!configurator.threeKitData || configurator.threeKitData.length < 1) {
        <img src="/images/1.jpg" class="img-fluid img-thumbnail" alt="..." />
      }
      @if (isConfigLocked()) {
        <div class="projectLocking" (click)="editConfig()">
          <a>
            <img src="/images/project-edit.svg" />
          </a>
        </div>
      }
    </div>
  </a>
  <h3 class="projectTile">{{ configurator.configurationName }}</h3>
  @if (configurator.status === 'EXPIRED') {
    <p class="text-danger text-center">
      {{ 'configuratorsList.configExpired' | cxTranslate }}
      <img class="globe" src="/images/circle-error.svg" />
    </p>
  }
  @if (configurator.status === 'APPROVED_LOCKED') {
    <p class="text-success text-center">
      {{ 'configuratorsList.approvedLocked' | cxTranslate }}
      <img class="globe" src="/images/circle-checked-outline-blue.svg" />
    </p>
  }
</ng-container>
